<template>
	<!-- Loading page -->
	<Layout>
		<div class="preloader">
			<div id="status">
				<b-spinner
					style="width: 3rem; height: 3rem"
					label="Large Spinner"
					variant="primary"
				/>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/views/layouts/Main.vue'

export default {
	page: {
		title: 'Loading...',
		meta: [{ name: 'description', content: 'Loading page...' }]
	},
	name: 'Loading',
	components: { Layout }
}
</script>
